<div>
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div>
      <p class="heading m-0">All Execution Report (Excluding Scheduler)</p>
      <div class="counter-row mt-1" *ngIf="!loading && !errorMessage">
        <span class="counter-pill counter-total">Total: {{ totalCount }}</span>
        <span class="counter-pill counter-running">Running: {{ runningCount }}</span>
        <span class="counter-pill counter-completed">Completed: {{ completedCount }}</span>
        <span class="counter-pill counter-incomplete">Incomplete: {{ incompleteCount }}</span>
        <span class="counter-pill counter-terminated">Terminated: {{ terminatedCount }}</span>
      </div>
    </div>
    <div class="d-flex">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary mr-2"
        [disabled]="downloadLoading"
        (click)="downloadReport()"
      >
        {{ downloadLoading ? 'Downloading...' : 'Download XLS' }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" [disabled]="loading" (click)="fetchReport()">
        {{ loading ? 'Running...' : 'Run' }}
      </button>
    </div>
  </div>

  <div class="widget-subtitle mb-2">
    Use full filters like test suite report to view non-scheduler executions.
  </div>

  <div class="row no-gutters mb-2">
    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Project Type</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedProjectTypeId" (change)="onProjectTypeChange()">
        <option *ngFor="let projectType of projectTypeList" [value]="projectType.projectTypeId">
          {{ projectType.projectTypeName }}
        </option>
      </select>
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Region</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedRegionId" (change)="onRegionChange()">
        <option value="0">All</option>
        <option *ngFor="let region of regionList" [value]="region.regionId">
          {{ region.regionCode || region.regionName }}
        </option>
      </select>
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Brand</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedBrandId">
        <option value="0">All</option>
        <option *ngFor="let brand of brandList" [value]="brand.brandId">
          {{ brand.brandName }}
        </option>
      </select>
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Platform</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedPlatformId">
        <option value="0">All</option>
        <option *ngFor="let platformOption of platformList" [value]="platformOption.platformId">
          {{ platformOption.platformName }}
        </option>
      </select>
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Testing Type</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedTestingType">
        <option *ngFor="let type of testingTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Build Name</label>
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Build name"
        [(ngModel)]="buildName"
      />
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">Executed By</label>
      <div class="user-filter-dropdown" [class.open]="showUserDropdown">
        <button
          type="button"
          class="form-control form-control-sm text-left user-filter-toggle"
          (click)="toggleUserDropdown()"
        >
          <span>{{ userFilterLabel }}</span>
          <span class="user-filter-caret">&#9662;</span>
        </button>

        <div class="user-filter-menu" *ngIf="showUserDropdown">
          <div class="user-filter-actions" *ngIf="userOptions.length > 0">
            <button type="button" class="btn btn-link btn-sm p-0 mr-2" (click)="selectAllUsers()">
              Select All
            </button>
            <button type="button" class="btn btn-link btn-sm p-0" (click)="clearUserSelection()">
              Clear
            </button>
          </div>

          <div class="user-filter-empty" *ngIf="userOptions.length === 0">
            No users available
          </div>

          <div class="user-filter-list" *ngIf="userOptions.length > 0">
            <label class="user-filter-option" *ngFor="let user of userOptions">
              <input
                type="checkbox"
                [checked]="isUserSelected(user)"
                (change)="onUserSelectionChange(user, $event.target.checked)"
              />
              <span>{{ user }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row no-gutters mb-2">
    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">From</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
    </div>

    <div class="col-md-6 pr-2 mb-2">
      <label class="filter-label">To</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-msg mb-2">{{ errorMessage }}</div>
  <div *ngIf="loading" class="no-record">Loading execution report...</div>

  <div class="table-responsive" *ngIf="!loading && !errorMessage">
    <table class="table table-sm table-striped table-bordered m-0" *ngIf="reportRows.length > 0">
      <thead>
        <tr>
          <th>Execution Name</th>
          <th>Testing Type</th>
          <th>Pass</th>
          <th>Fail</th>
          <th>Skip</th>
          <th>Total</th>
          <th>Build Details</th>
          <th>Status</th>
          <th>Executed By</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of visibleRows">
          <td>{{ row.executionName }}</td>
          <td>{{ row.testingType }}</td>
          <td class="pass-text">{{ row.passCount }}</td>
          <td class="fail-text">{{ row.failCount }}</td>
          <td class="skip-text">{{ row.skipCount }}</td>
          <td>{{ row.passCount + row.failCount + row.skipCount }}</td>
          <td>{{ row.buildName }}</td>
          <td>
            <span
              [ngClass]="{
                'status-running': row.jobStatus === 1,
                'status-completed': row.jobStatus === 2,
                'status-incomplete': row.jobStatus === 3,
                'status-terminated': row.jobStatus === 4,
                'status-unknown': row.jobStatus !== 1 && row.jobStatus !== 2 && row.jobStatus !== 3 && row.jobStatus !== 4
              }"
            >
              {{ row.statusText }}
            </span>
          </td>
          <td>{{ row.createdBy }}</td>
        </tr>
      </tbody>
    </table>

    <div class="no-record" *ngIf="reportRows.length === 0 && !errorMessage">
      No execution rows found for selected filter.
    </div>
  </div>

  <div class="d-flex justify-content-end mt-2" *ngIf="!loading && canSeeMore">
    <span class="see-more-link" (click)="toggleSeeMore()">
      {{ showAll ? 'See Less...' : 'See More...' }}
    </span>
  </div>
</div>
